import React from 'react';
import { useIntl } from 'react-intl';

import { IconButton } from '../../../components/IconButton/IconButton';
import { exportXlsx } from '../../../utils/exportXlsx';
import { UI_TABLE_EXPORT_EXCEL_ICON_TESTID } from '../constants';

function ExportXlsxAction({ state }) {
  const intl = useIntl();
  const handleClick = async () => {
    await exportXlsx({
      data: state.data,
      name: state.name,
    });
  };

  const title = intl.formatMessage({
    id: 'ExportXlsxAction.title',
    defaultMessage: 'Export Excel',
    description: 'Button to export table data to Excel',
  });

  return (
    <div className={UI_TABLE_EXPORT_EXCEL_ICON_TESTID}>
      <IconButton
        icon="download"
        size="s"
        tooltip={title}
        onClick={handleClick}
      />
    </div>
  );
}

export default ExportXlsxAction;
